export default {
  bot_name: 'Bot',
  customer_name: 'Cliente',
  priority: 'Prioridade',
  queue_time: 'Tempo na fila',
  sequential_id: 'Ticket',
  team: 'Fila',
};
